import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import _ from 'lodash';
import classNames from 'classnames';
import SearchField from '../../components/SearchField';
import School from '../../components/School';
import Loader from '../../components/Loader';
/* eslint-disable import/no-named-as-default */
import Button from '../../components/Button';
import Mapbox from '../../components/Mapbox';
import FilterSelect from '../../components/FilterSelect';
import { withRtl } from '../../components/hoc';
import style from './LoggedIn.scss'; // eslint-disable-line css-modules/no-unused-class
import { getSchools, getWaitlistsSubmissionsState } from '../../actions/schools';
import { getFilters, resetCustomFilters } from '../../actions/filters';
import { getSchoolsAutocomplete } from '../../actions/autocomplete';
import studentInfo from '../../actions/studentInfo';
import { getStudentApplications } from '../../actions/student';
import setPage, { resetPagination } from '../../actions/pagination';
import { addParameterAndSearch, applyFilters } from '../../actions/addParameter';
import schoolsToMarker from '../../services/schoolsToMarker';
import Default, { Mobile } from '../../utils/mediaQueries';
import {customisedIntlFormatMessage} from '../../utils/helpers';
import SearchAndFilter from '../../components/SearchAndFilter';
import history from '../../history';
import SearchNoResults from '../../components/SearchNoResults';
import messages from '../../locale/messages';
import CoachmarksSearch from '../../coachmarksLocale/search/search';
import Coachmarks from '../../components/Coachmarks';
import analytics from '../../services/analytics';
import { CoachmarksSummerRisingSearch } from '../../coachmarksLocale/coachmarks';
/* eslint-disable css-modules/no-undef-class */
const localMessages = defineMessages({
  studentAddressNotGeocoded: {
    id: 'search.studentAddressNotGeocoded',
    defaultMessage:
      'Student’s residential address is not specified or\n' +
      'recognized. Zoned school and schools’ distances\n' +
      'from home are not shown. Eligibilities may be\n' +
      'inaccurate.',
    description: 'Student address is not geocoded.',
  },
  directoryAlertMessage: {
    id: 'user.directoryAlertMessage',
    defaultMessage:
      'Family Welcome Center locations are now closed, but our staff is available to assist you! Please visit schools.nyc.gov/WelcomeCenters to learn how you can reach us.',
    description: 'Directory Alert Message',
  },
});

// const SCHOOLS = 'SCHOOLS';
// const MAP = 'MAP';

class LoggedIn extends Component {
  static propTypes = {
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
    filtersLoaded: PropTypes.bool.isRequired,
    filtersLoading: PropTypes.bool.isRequired,
    schools: PropTypes.shape({
      autocomplete: PropTypes.shape({
        autocompleteSchools: PropTypes.arrayOf(PropTypes.string),
        autocompleteSchoolsId: PropTypes.arrayOf(PropTypes.number),
        autocompleteSchoolsDbn: PropTypes.arrayOf(PropTypes.string),
      }).isRequired,
      optionsDict: PropTypes.shape({}).isRequired,
      loaded: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
      normalSchools: PropTypes.shape(),
      count: PropTypes.number,
    }).isRequired,
    user: PropTypes.shape({
      isSHS: PropTypes.bool.isRequired,
      isGT: PropTypes.bool.isRequired,
      isMS: PropTypes.bool.isRequired,
      is2K: PropTypes.bool.isRequired,
      is3K: PropTypes.bool.isRequired,
      isPK: PropTypes.bool.isRequired,
      address: PropTypes.string.isRequired,
      applicationId: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      admissionProcess: PropTypes.string.isRequired,
      directoryAlertMessage: PropTypes.string,
      isWaitlist: PropTypes.bool,
      details: PropTypes.shape({
        data: PropTypes.shape({
          applications: PropTypes.number,
          current_grade: PropTypes.string,
          zoned_ms_school: PropTypes.shape({
            borough: PropTypes.string,
          }),
          current_school: PropTypes.shape({
            borough: PropTypes.string,
          }),
          address: PropTypes.shape({
            address_1: PropTypes.string,
            latitude: PropTypes.number,
            longitude: PropTypes.number,
          }),
        }),
      }),
    }).isRequired,
    userDetails: PropTypes.shape({
      current_grade: PropTypes.string,
    }).isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
      formatMessage: PropTypes.func,
    }).isRequired,
    isRtl: PropTypes.bool,
    page: PropTypes.shape({ page: PropTypes.number.isRequired, last: PropTypes.bool.isRequired }).isRequired,
    customFilters: PropTypes.shape().isRequired,
    dispatch: PropTypes.func.isRequired,
    /*
      TODO CREATE PAGINATION
      isFetching: PropTypes.bool.isRequired,
      // onLoadMoreClick: PropTypes.func.isRequired,
      nextPageUrl: PropTypes.string,
      loadingLabel: PropTypes.string.isRequired,
    */
  };

  static defaultProps = {
    isRtl: false,
  };

  constructor(props) {
    super(props);
    this.hasAddedZonedCoachmark = false;

    this.coachmarksPK = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOnePK)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepTwoParagraphTwoPK,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOnePK)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepThreeParagraphTwoPK,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphOnePK)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepFiveParagraphTwoPK,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSix),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];
    this.coachmarksPKMobile = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOnePK),
      },
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphTwoPK),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOnePK),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphTwoPK),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphOnePK),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphTwoPK),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];

    this.coachmarks3K = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne3K)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepTwoParagraphTwo3K,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphOnePK)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepFiveParagraphTwoPK,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphOne3k),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];
    this.coachmarks3KMobile = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne3K),
      },
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphTwo3K),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphTwoPK),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphOne3k),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];

    this.coachmarks2K = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: `${props.intl.formatMessage(CoachmarksSearch.stepTwoParagraphOne2K)}${props.intl.formatMessage(
          CoachmarksSearch.stepTwoParagraphTwo3K,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepFiveParagraphOnePK),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepSixParagraphOne3k),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepEight),
      },
    ];
    this.coachmarks2KMobile = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepTwoParagraphOne2K),
      },
      {
        element: '[data-coachmark="search-step-2"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepTwoParagraphTwo3K),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepFiveParagraphOnePK),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepSixParagraphOne3k),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: props.intl.formatMessage(CoachmarksSearch.stepEight),
      },
    ];

    this.coachmarksHS = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepTwoParagraphTwo,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOne)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepThreeParagraphTwo,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphOne)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepFiveParagraphTwo,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSix),
      },
      {
        element: '[data-coachmark="search-step-7"]',
        intro: this.props.user.show_loo_tooltip ? this.props.user.search_coachmark_step_7 : customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSeven),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];
    this.coachmarksHSMobile = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-7"]',
        intro: this.props.user.show_loo_tooltip ? this.props.user.search_coachmark_step_7 : customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSeven),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];

    this.coachmarksMS = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepTwoParagraphTwo,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOne)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepThreeParagraphTwo,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: `${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepFiveParagraphOneMiddleSchool,
        )}${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphTwo)}`,
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSix),
      },
      {
        element: '[data-coachmark="search-step-7"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSevenMiddleSchool),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];
    this.coachmarksMSMobile = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphOneMiddleSchool),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-7"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSevenMiddleSchool),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];
    this.coachmarksSR = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepOneParagraphOneForAfiliated),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepThreeParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepFiveParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepSix),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepEight),
      },
    ];

    this.coachmarksSRMobile = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepOneParagraphOneForAfiliated),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepThreeParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepFiveParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepSix),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSummerRisingSearch.stepEight),
      },
    ];

    this.coachmarksK = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepTwoParagraphTwo,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: `${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOne)}${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepThreeParagraphTwoKindergarten,
        )}`,
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: `${customisedIntlFormatMessage(props.intl, 
          CoachmarksSearch.stepFiveParagraphOneMiddleSchool,
        )}${customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphTwoKindergarten)}`,
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSix),
      },
      {
        element: '[data-coachmark="search-step-7"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSevenKindergarten),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];
    this.coachmarksKMobile = [
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-2"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepTwoParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-3"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepThreeParagraphTwoKindergarten),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphOneMiddleSchool),
      },
      {
        element: '[data-coachmark="search-step-5"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepFiveParagraphTwoKindergarten),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphOne),
      },
      {
        element: '[data-coachmark="search-step-6"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSixParagraphTwo),
      },
      {
        element: '[data-coachmark="search-step-7"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepSevenKindergarten),
      },
      {
        element: '[data-coachmark="search-step-8"]',
        intro: customisedIntlFormatMessage(props.intl, CoachmarksSearch.stepEight),
      },
    ];
    this.zoned3KPKCoachmark = {
      element: '[data-coachmark="search-step-2"]',
      intro: this.props.user.stepZoned3KPK
    };
    this.zonedKCoachmark = {
      element: '[data-coachmark="search-step-2"]',
      intro: this.props.user.stepZonedK
    };
    this.zonedMSHSCoachmark = {
      element: '[data-coachmark="search-step-2"]',
      intro: this.props.user.stepZonedMSHS
    };
    this.zonedGTCoachmark = {
      element: '[data-coachmark="search-step-2"]',
      intro: this.props.user.stepZonedGT
    };

    switch (this.props.user.admissionProcess) {
      case 'PK':
        this.coachmarks = this.coachmarksPK;
        this.coachmarksMobile = this.coachmarksPKMobile;
        this.coachmarkZoned = this.zoned3KPKCoachmark;
        break;
      case '3K':
        this.coachmarks = this.coachmarks3K;
        this.coachmarksMobile = this.coachmarks3KMobile;
        this.coachmarkZoned = this.zoned3KPKCoachmark;
        break;
      case '2K':
        this.coachmarks = this.coachmarks2K;
        this.coachmarksMobile = this.coachmarks2KMobile;
        break;
      case 'K':
        this.coachmarks = this.coachmarksK;
        this.coachmarksMobile = this.coachmarksKMobile;
        this.coachmarkZoned = this.zonedKCoachmark;
        break;
      case 'MS':
        this.coachmarks = this.coachmarksMS;
        this.coachmarksMobile = this.coachmarksMSMobile;
        this.coachmarkZoned = this.zonedMSHSCoachmark;
        break;
      case 'HS':
        this.coachmarks = this.coachmarksHS;
        this.coachmarksMobile = this.coachmarksHSMobile;
        this.coachmarkZoned = this.zonedMSHSCoachmark;
        break;
      case 'SR':
        this.coachmarks = this.coachmarksSR;
        this.coachmarksMobile = this.coachmarksSRMobile;
        break;
      case 'GTAPP':
        this.coachmarks = [];
        this.coachmarksMobile = [];
        this.coachmarkZoned = this.zonedGTCoachmark;
        break;
      default:
        this.coachmarks = null;
        this.coachmarksMobile = null;
    }

    // this.interval = null;

    this.state = {
      // hoveredSchool: false,
      mobileMapIsOpen: false,
      currentSchoolDetail: null,
      currentProgramId: 0,
      isComingFromMobileMap: false,
      loaded: false,
      // firstSchoolsRender: false,
      // countdown: 10, // change this value to give calculations more time to run
    };

    const urlParams = new URLSearchParams(window.location.search);
    this.showSavedProgramsOnly = urlParams.get('saves');
  }

  addZonedCoachmark() {
    if (this.hasAddedZonedCoachmark) {
      return;
    }
    this.coachmarks.splice(this.coachmarks.length, 0, this.coachmarkZoned);
    this.coachmarksMobile.splice(this.coachmarksMobile.length, 0, this.coachmarkZoned);
    this.hasAddedZonedCoachmark = true;
  }

  componentDidMount() {
    const { user, customFilters, dispatch } = this.props;
    const { loaded } = this.state;
    const { applicationId } = user;
    if (loaded) {
      return;
    }

    let tasks = [];
    let getWaitlistsSubmissionState = Promise.resolve();
    let getSchoolsTask = Promise.resolve();
    if (!customFilters.optionsDict) {
      getSchoolsTask = dispatch(getSchools({})).catch(error => {
        console.error('Failed to getSchools', error);
      });
    }
    const getFiltersTask = dispatch(getFilters({})).catch(error => {
      console.error('Failed to getFilters', error);
    });
    const studentInfoTask = dispatch(studentInfo(applicationId)).catch(error => {
      console.error('Failed to studentInfo', error);
    });

    if (!user.isWaitlist) {
      const getStudentApplicationsTask = dispatch(getStudentApplications(applicationId)).catch(error => {
        console.error('Failed to getStudentApplications', error);
      });
      tasks.push(getStudentApplicationsTask);
    } else if (user.isWaitlist) {
      getWaitlistsSubmissionState = dispatch(getWaitlistsSubmissionsState()).catch(error => {
        console.error('Failed to getWaitlistsSubmissionState', error);
      });
    }

    tasks = [getSchoolsTask, getFiltersTask, studentInfoTask, getWaitlistsSubmissionState];

    Promise.all([
      //
      ...tasks,
    ])
      .then(() => {
        this.setState({
          ...this.state,
          loaded: true,
          // firstSchoolsRender: true,
        });
      })
      .catch(error => {
        console.error('Error', error);
      });
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.schools.optionsDict !== this.props.schools.optionsDict) {
  //     this.props.getSchools();
  //   }
  //
  //   if (nextProps.customFilters.optionsDict && nextProps.filtersLoaded) {
  //     nextProps.customFilters.filterMapping.forEach(mapping => {
  //       const filter = nextProps.filters[mapping.filter];
  //       if (!filter) {
  //         return;
  //       }
  //
  //       const optionGroup = filter.optionGroups[mapping.optionGroup];
  //       if (!optionGroup) {
  //         return;
  //       }
  //
  //       const option = optionGroup.options[mapping.option];
  //       if (!option) {
  //         return;
  //       }
  //       option.selected = true;
  //     });
  //
  //     nextProps.applyFilters(nextProps.customFilters.optionsDict);
  //     nextProps.resetCustomFilters();
  //   }
  // }

  async componentDidUpdate(prevProps, prevState) {
    // Keep the mobile map mounted once it's been opened: toggling back to the list
    // CSS-hides it instead of unmounting, so reopening doesn't re-fire a map-sessions
    // beacon or hit the broken reuse path. (Mount condition is in render.)
    if (this.state.mobileMapIsOpen && !this.state.mobileMapHasOpened) {
      this.setState({ mobileMapHasOpened: true });
    }
    const { schools, intl, dispatch } = this.props;
    if (
      prevProps.customFilters.optionsDict &&
      prevProps.filtersLoaded &&
      prevProps.schools.optionsDict === schools.optionsDict
    ) {
      prevProps.customFilters.filterMapping.forEach(mapping => {
        const filter = prevProps.filters[mapping.filter];
        if (!filter) {
          return;
        }

        const optionGroup = filter.optionGroups[mapping.optionGroup];
        if (!optionGroup) {
          return;
        }

        const option = optionGroup.options[mapping.option];
        if (!option) {
          return;
        }
        option.selected = true;
      });

      dispatch(applyFilters(prevProps.customFilters.optionsDict));
      dispatch(resetCustomFilters());
    }

    if (prevProps.schools.optionsDict !== schools.optionsDict) {
      dispatch(getSchools({}));
    }

    if (prevProps.intl.locale !== intl.locale) {
      dispatch(getSchools({}));
      dispatch(getFilters({}));
    }
    // if (!prevProps.schools.length && this.state.firstSchoolsRender && !this.interval) {
    //   this.interval = setInterval(() => this.tickCountdown(), 1000);
    // }
    // if (prevState.countdown === 1) {
    //   clearInterval(this.interval);
    //   await this.setState({
    //     ...this.state,
    //     firstSchoolsRender: false,
    //   });
    //   await dispatch(getSchools({}));
    // }
  }

  // componentWillUnmount() {
  //   if (this.interval) {
  //     clearInterval(this.interval);
  //   }
  // }

  // tickCountdown = () => {
  //   this.setState({
  //     ...this.state,
  //     countdown: this.state.countdown - 1,
  //   });
  // };

  getBoundingSchoolPins = _.debounce((neCoords, swCoords) => {
    const { dispatch } = this.props;
    dispatch(
      getSchools({
        processName: this.processName,
        mapBounds: `ne_coords=${neCoords.join(',')}&sw_coords=${swCoords.join(',')}&`,
      }),
    );
  }, 1500);

  getMarkers = () => {
    const { normalSchools, loading, loaded } = this.props.schools;
    let markers = [];
    if (loading) {
      return markers;
    } else if (loaded) {
      markers = schoolsToMarker(normalSchools, normalSchools.result);
    }
    return markers;
  };

  getFilters = () => {
    const { filters, filtersLoading, filtersLoaded, customFilters, userDetails, user } = this.props;
    let filtersLoad = null;
    const urlParams = new URLSearchParams(window.location.search);
    const filters_applied = urlParams.get('filters_applied')
    let optionsDict = null;
    if (filters_applied) {
      optionsDict = this.props.schools.optionsDict;
    }
    if (customFilters.optionsDict || filtersLoading) {
      filtersLoad = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return filtersLoad;
    } else if (filtersLoaded) {
      // temporarily set "10th Grade Seats Available" filter to selected for ninth graders in HS applications
      const HSninthGrader = userDetails.current_grade === '09' && !user.isSHS;
      /* if (HSninthGrader) {
        const opt = filters[3].optionGroups[1].options[0];
        // do not set selected = true to avoid filter button highlight and selected count display, prevent reset
          opt.true = {
          id: opt.value,
          label: opt.label,
          section: opt.id,
        };
      } */

      filtersLoad = (
        <div className={style.filters}>
          {filters.map(filter => {
            if (optionsDict || this.showSavedProgramsOnly) {
              _.map(filter.optionGroups, options => {
                _.map(options.options, indOptionSet => {
                  if (optionsDict && optionsDict.hasOwnProperty(indOptionSet.id) && optionsDict[indOptionSet.id].includes(indOptionSet.value)) {
                    indOptionSet.selected = true;
                    indOptionSet.true = {
                      id: indOptionSet.value,
                      label: indOptionSet.label,
                      section: indOptionSet.id,
                    }
                  }
                  if(indOptionSet.id=='saved_programs' && this.showSavedProgramsOnly && this.showSavedProgramsOnly == '1'){
                    indOptionSet.selected = true; 
                    indOptionSet.true = {
                      id: indOptionSet.value,
                      label: indOptionSet.label,
                      section: indOptionSet.id,
                    }
                  }
                })
              })
            }
            const allOptions = filter.optionGroups.map(({ options }) => options);
            const selected = _.flattenDeep(allOptions)
              // eslint-disable-next-line no-shadow
              .map(({ selected }) => selected)
              .filter(n => n);

            return (
              <FilterSelect
                key={filter.label}
                label={filter.label}
                optionGroups={filter.optionGroups}
                apply={this.handleApplyFilter}
                reset={this.handleResetFilter}
                selected={selected.length}
                HSninthGrader={HSninthGrader}
                selectSavedProgramsFilter={this.showSavedProgramsOnly}
              />
            );
          })}
        </div>
      );
    }
    return filtersLoad;
  };

  previousPage = () => {
    const { dispatch } = this.props;
    dispatch(setPage('down'));
    dispatch(getSchools({}));
    window.scrollTo(0, 0);
  };

  nextPage = () => {
    const { dispatch } = this.props;
    dispatch(setPage('up'));
    dispatch(getSchools({}));
    window.scrollTo(0, 0);
  };

  handleCloseDetailView = () => {
    const { isComingFromMobileMap } = this.state;
    this.state.currentSchoolDetail = null;
    this.setState({
      ...this.state,
      currentSchoolDetail: null,
      currentProgramId: 0,
      mobileMapIsOpen: !!isComingFromMobileMap,
      isComingFromMobileMap: false,
    });

    const { pathname } = history.location;
    if (this.showSavedProgramsOnly)
      history.push(pathname + '?saves=' + this.showSavedProgramsOnly);
    else
      history.push(pathname)
  };

  handleProgramClick = (id, schoolId, dbn) => {
    const { currentProgramId, currentSchoolDetail, mobileMapIsOpen, isComingFromMobileMap } = this.state;
    // sk: if we are in school detail
    // all user interactions are intentional
    if (id !== currentProgramId) {
      this.setState({
        ...this.state,
        currentSchoolDetail: schoolId,
        mobileMapIsOpen: false,
        isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
      });
    }

    if (currentSchoolDetail !== schoolId) {
      const { pathname } = history.location;
      let newURL = `${pathname}?dbn=${dbn}`;
      if (this.showSavedProgramsOnly)
        newURL = this.appendSavesURL(newURL);
      history.push(newURL);
    }

    document.body.style.overflow = 'initial';
  };

  appendSavesURL = (url) => {
    return url + '&saves=' + this.showSavedProgramsOnly
  }

  handleSchoolClick = (id, dbn) => {
    const { currentSchoolDetail, currentProgramId, mobileMapIsOpen, isComingFromMobileMap } = this.state;
    if (currentSchoolDetail === id) {
      // CURRENT SCHOOL
      if (currentProgramId) {
        // clicking a school map title AND we have a program open
        this.setState({
          ...this.state,
          currentProgramId: 0,
          mobileMapIsOpen: false,
          isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
        });
      } else {
        // clicking the school map title when school card is open and no program is open
        this.setState({
          ...this.state,
          currentSchoolDetail: id,
          currentProgramId: 1,
          mobileMapIsOpen: false,
          isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
        });
      }
    } else {
      const { pathname } = history.location;
      let newURL = `${pathname}?dbn=${dbn}`;
      if (this.showSavedProgramsOnly)
        newURL = this.appendSavesURL(newURL);
      history.push(newURL);
      this.setState({
        ...this.state,
        currentSchoolDetail: id,
        currentProgramId: 0,
        mobileMapIsOpen: false,
        isComingFromMobileMap: !!mobileMapIsOpen || isComingFromMobileMap,
      });
      setTimeout(function () {
        window.scrollTo(0, 0)
      }, 1000);
    }
    document.body.style.overflow = 'initial';
  };

  handleApplyFilter = ({ optionGroups }) => {
    this.handleCloseDetailView()
    const { dispatch } = this.props;
    if (optionGroups.search) {
      this.setState({
        ...this.state,
        string: optionGroups.search[0],
      });
    }
    dispatch(addParameterAndSearch(optionGroups));
  };

  handleResetFilter = () => {
    const { dispatch } = this.props;
    dispatch(resetPagination());
  };

  handleApplyFilters = ({ filters }) => {
    const { dispatch } = this.props;
    const realOptionGroups = [];
    filters.map(({ optionGroups }) =>
      optionGroups.map(item => {
        realOptionGroups.push(item);
        return item;
      }),
    );

    dispatch(addParameterAndSearch(realOptionGroups));
  };

  // handleResetFilters = ({ filters }) => {};

  mapPlaceholder = () => {
    this.mapClick();
  };

  mapClick = () => { };

  handleToggleMapForMobileView = ({ isOpen }) => {
    this.setState({
      ...this.state,
      mobileMapIsOpen: isOpen,
    });
  };

  handleSearchfieldAutocomplete = _.debounce(string => {
    const {
      dispatch,
      schools: { optionsDict: options },
      user: {
        details: {
          data: {
            address,
          },
        },
      },
    } = this.props;
    dispatch(
      getSchoolsAutocomplete({
        query: string,
        options,
        latLng: address && address.longitude ? `longitude=${address.longitude}&latitude=${address.latitude}&` : '',
      }),
    );
  }, 1000);

  showAutocompleteSchoolDetail = string => {
    const { schools, dispatch } = this.props;
    const { autocompleteSchools, autocompleteSchoolsDbn } = schools.autocomplete;
    const dbn = autocompleteSchoolsDbn[autocompleteSchools.indexOf(string)];
    analytics({
      eventLabel: 'autocompleteSchoolClick',
      dataDictionary: {
        schoolName: `${string}`,
        schoolDbn: `${dbn}`,
        loggedIn: true
      },
    });

    dispatch(getSchools({ extra: `/${dbn}`, isAutoComplete: true }));
    let { pathname } = history.location;
    if (pathname.substr(-1) === '/') {
      pathname = pathname.substr(0, pathname.length - 1);
    }
    if (this.showSavedProgramsOnly)
      history.push(`${pathname}/${dbn}?saves=${this.showSavedProgramsOnly}`);
    else
      history.push(`${pathname}/${dbn}`);
  };

  renderSchools = () => {
    const { isRtl, intl, page, customFilters, user, schools } = this.props;
    const { normalSchools, loading, loaded } = schools;
    const { applicationId, firstName, admissionProcess } = user;
    const { currentSchoolDetail, currentProgramId } = this.state;
    let load = null;
    if (customFilters.optionsDict || loading) {
      load = (
        <li className={style.listItem}>
          <Loader />
        </li>
      );
      return load;
    } else if (loaded) {
      if (window.App.state.user.admissionProcess === 'SR' || admissionProcess === 'SR') {
        const affiliatedLocationExists = normalSchools.entities.school && Object.values(normalSchools.entities.school).some(
          entry => entry.isAffiliatedSRLocation === true
        );
        if (!affiliatedLocationExists){
          this.coachmarks[0].intro = customisedIntlFormatMessage(intl, CoachmarksSummerRisingSearch.stepOneParagraphOneForNonAfiliated);
          this.coachmarksMobile[0].intro = customisedIntlFormatMessage(intl, CoachmarksSummerRisingSearch.stepOneParagraphOneForNonAfiliated);
        }
      }
      const hasZonedSchools = normalSchools.entities.school && Object.values(normalSchools.entities.school).some(
        entry => entry.is_zoned_school === true
      );
      if (hasZonedSchools) {
        this.addZonedCoachmark();
      }

      load = (
        <li className={classNames(style.listItem, style.listItemPagination) + ' exclude-print'}>
          <button
            className={classNames('button', style.paginationButton, style.paginationButtonPrevious, {
              [style.paginationButtonDisabled]: page.page === 1,
            })}
            aria-label={customisedIntlFormatMessage(intl, messages.buttonSchoolsSearchPrevious)}
            onClick={this.previousPage}
            disabled={page.page === 1}
          >
            <i className={`icon-caret-${isRtl ? 'right' : 'left'}`} />
          </button>
          <button
            className={classNames('button', style.paginationButton, style.paginationButtonNext, {
              [style.paginationButtonDisabled]: page.last,
            })}
            aria-label={customisedIntlFormatMessage(intl, messages.buttonSchoolsSearchNext)}
            onClick={this.nextPage}
            disabled={page.last}
          >
            <i className={`icon-caret-${isRtl ? 'left' : 'right'}`} />
          </button>
        </li>
      );
    }

    if (!normalSchools.result.length) {
      return <SearchNoResults />;
    }

    if (currentSchoolDetail !== null) {
      return (
        <ul className={style.list}>
          <li key="detail" className={style.listItem}>
            <School
              {...normalSchools.entities.school[currentSchoolDetail]}
              loggedIn
              onClick={this.handleSchoolClick}
              showDetails
              headerOpen={!currentProgramId}
              programClick={this.handleProgramClick}
              programOpen={currentProgramId}
              firstName={firstName}
              user={user}
              admissionProcess={admissionProcess}
              is_last_school={true}
            />
          </li>
        </ul>
      );
    }

    return (
      <ul className={style.list}>
        {normalSchools.result.map((id, index) => {
          let is_last_school = index + 1 == normalSchools.result.length;
          return (<li
            data-coachmark="search-step-2"
            key={id}
            className={style.listItem}
            ref={el => {
              this[id] = el;
            }}
          >
            <School
              {...normalSchools.entities.school[id]}
              url={`/dashboard/${applicationId}/schools/${id}`}
              applicationId
              loggedIn
              onClick={this.handleSchoolClick}
              programClick={this.handleProgramClick}
              firstName={firstName}
              admissionProcess={admissionProcess}
              is_last_school={is_last_school}
            />
          </li>)
        })}
        {load}
      </ul>
    );
  };

  render() {
    const { filters, intl, schools, user } = this.props;
    const { autocompleteSchools } = schools.autocomplete;
    const {
      current_grade: currentGrade,
      current_school: currentSchool,
      zoned_ms_school: zonedMSSchool,
    } = user.details.data;
    // const { hoveredSchool, mobileMapIsOpen, currentSchoolDetail, isComingFromMobileMap, loaded } = this.state;
    const { mobileMapIsOpen, currentSchoolDetail, isComingFromMobileMap, loaded } = this.state;
    const { count } = schools;
    const sidebarClasses = [style.sidebar];
    const mapClasses = [style.map];
    if (mobileMapIsOpen) {
      sidebarClasses.push(style.sidebarMapIsClicked);
      mapClasses.push(style.mapMapIsClicked);
    }

    const backButtonLabel = isComingFromMobileMap
      ? customisedIntlFormatMessage(intl, messages.generalStringBackToMap)
      : customisedIntlFormatMessage(intl, messages.generalStringBackToList);

    const mapProps = {
      ...this.props,
      markers: this.getMarkers(),
      // onMapMove: this.mapPlaceholder,
      // onMarkerClick: this.mapClick,
      // label: hoveredSchool,
      // onMarkerHover: this.handleShow,
      popupClickHandlers: {
        onSchoolNameClick: this.handleSchoolClick,
        onProgramClick: this.handleProgramClick,
      },
      currentSchoolDetail,
      getBoundingSchoolPins: this.getBoundingSchoolPins,
      // re-fit the map when the user pages through results (see Mapbox.componentDidUpdate).
      // Overrides the page object spread above with the page number for a clean compare.
      page: this.props.page.page,
    };
    const search_page_message_for_two_k_applicants = user?.details?.data?.search_page_message_for_two_k_applicants || '';
    let studentAddressNotGeocoded = null;
    if (
      !user.details.data.applications &&
      (!user.details.data.address.address_1.length || !user.details.data.address.latitude)
    ) {
      studentAddressNotGeocoded = (
        <div className={style.geolocationWarning}>
          <FormattedMessage {...localMessages.studentAddressNotGeocoded} />
        </div>
      );
    }
    let availableSchoolsMessage;
    if (user.isMS) {
      availableSchoolsMessage = messages.generalStringSortLabelMiddleSchools;
    } else if (user.isPK) {
      availableSchoolsMessage = messages.generalStringSortLabelPreKindergartenProviders;
    } else if (user.is2K) {
      availableSchoolsMessage = messages.generalStringSortLabel2KProviders;
    } else if (user.is3K) {
      availableSchoolsMessage = messages.generalStringSortLabel3KProviders;
    } else {
      availableSchoolsMessage = messages.generalStringSortLabelSchools;
    }

    let searchBarHeader;
    if (user.isPK || user.is2K || user.is3K) {
      searchBarHeader = messages.generalStringSearchAllPrograms;
    } else {
      searchBarHeader = messages.generalStringSearchAllSchoolsAndPrograms;
    }

    let searchBarPlaceholder;
    if (user.isPK || user.is2K || user.is3K) {
      searchBarPlaceholder = messages.searchfieldPlaceholderSchoolsForPKAnd3K;
    } else {
      searchBarPlaceholder = messages.searchfieldPlaceholderSchools;
    }

    if (!loaded) {
      return <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />;
    }

    let calculationAlert;
    if ((user.isPK || user.is2K || user.is3K) && user.directoryAlertMessage) {
      calculationAlert = (
        <div className={style.alertBox}>
          <span className={style.alertBoxText}><FormattedMessage {...localMessages.directoryAlertMessage} /></span>
        </div>
      );
    }

    return (
      <main className={style.root} role="presentation">
        <Mobile>
          {(
            <div data-coachmark="search-step-5">
              <SearchAndFilter
                filters={filters}
                toggleMap={this.handleToggleMapForMobileView}
                mapIsOpen={mobileMapIsOpen}
                apply={this.handleApplyFilters}
                searchfieldItems={autocompleteSchools}
                searchfieldOnClick={this.showAutocompleteSchoolDetail}
                searchfieldOnSearch={this.handleApplyFilter}
                searchfieldOnChangeValue={this.handleSearchfieldAutocomplete}
                user={user}
                selectSavedProgramsFilter={this.showSavedProgramsOnly}
                display={this.state.string || this.props.schools.optionsDict.search && this.props.schools.optionsDict.search[0]}
                isLoggedIn
              />
            </div>
          )}
          {user.is2K && search_page_message_for_two_k_applicants && (
            <div className={style.alertBox + " exclude-print"}>
              <div className={style.searchResultsMessageLabelNoCasing}>
                { search_page_message_for_two_k_applicants }
              </div>
            </div>
          )}
        </Mobile>
        <div className={style.flexRoot}>
          <div className={classNames(...sidebarClasses)}>
            {calculationAlert}
            {!schools.loading && studentAddressNotGeocoded}
            {(
              <Fragment>
                <Default>
                  <div className={style.pageLabel + ' exclude-print'}>
                    <i className="icon-Search" role="presentation" />
                    <h1>
                      <FormattedMessage {...searchBarHeader} />
                    </h1>
                  </div>
                  <div data-coachmark="search-step-5">
                    <SearchField
                      onChangeValue={this.handleSearchfieldAutocomplete}
                      onClick={this.showAutocompleteSchoolDetail}
                      placeholder={searchBarPlaceholder}
                      autocomplete
                      onSearch={this.handleApplyFilter}
                      items={autocompleteSchools}
                      user={user}
                      display={this.state.string || this.props.schools.optionsDict.search && this.props.schools.optionsDict.search[0]}
                    />
                    {this.getFilters()}
                  </div>
                  {user.is2K && search_page_message_for_two_k_applicants && (
                    <div className={style.alertBox + " exclude-print"}>
                      <div className={style.searchResultsMessageLabelNoCasing}>
                        { search_page_message_for_two_k_applicants }
                      </div>
                    </div>
                  )}
                  <div className={style.resultSetSortWrapper + " exclude-print"}>
                    {schools.loaded && (
                      <h2 className={style.searchResultsMessageLabel}>
                        <FormattedMessage {...availableSchoolsMessage} values={{ count }} />
                      </h2>
                    )}
                  </div>
                </Default>
                <Mobile>
                  <div className={style.resultSetSortWrapper}>
                    {schools.loaded && (
                      <h2 className={style.searchResultsMessageLabel}>
                        <FormattedMessage {...availableSchoolsMessage} values={{ count }} />
                      </h2>
                    )}
                  </div>
                </Mobile>
              </Fragment>
            )}
            {currentSchoolDetail && (
              <div className={style.backButtonWrapper}>
                <Default>
                  <Button
                    onClick={this.handleCloseDetailView}
                    iconLeft="arrow-left"
                    aria-label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
                    label={customisedIntlFormatMessage(intl, messages.generalStringBackToList)}
                    iconColor="#4ee4b3"
                    full
                    large
                  />
                </Default>
                <Mobile>
                  <Button
                    onClick={this.handleCloseDetailView}
                    iconLeft="arrow-left"
                    aria-label={backButtonLabel}
                    label={backButtonLabel}
                    iconColor="#4ee4b3"
                    full
                    large
                  />
                </Mobile>
              </div>
            )}
            {this.renderSchools()}
          </div>
          <div className={classNames(...mapClasses)}>
            <Default>
              <Mapbox {...mapProps} />
            </Default>
            <Mobile>
              {/* Lazy-mount the mobile map: don't instantiate mapbox-gl (a billable map
                  load) until the user first opens the map view. Once opened, keep it
                  mounted (visibility is CSS-toggled) so reopening doesn't re-initialize a
                  new map — avoids an extra map-sessions beacon and the broken-reuse path. */}
              {(mobileMapIsOpen || this.state.mobileMapHasOpened) && <Mapbox {...mapProps} mobile />}
            </Mobile>
          </div>
        </div>
        {schools.loaded && this.coachmarks && this.coachmarksMobile && (
          <div>
            <Default>
              <Coachmarks steps={this.coachmarks} context="search" />
            </Default>
            <Mobile>
              <Coachmarks steps={this.coachmarksMobile} context="search" />
            </Mobile>
          </div>
        )}
      </main>
    );
  }
}

const mapStateToProps = ({ schools, filters, user, page, customFilters }) => ({
  schools,
  user,
  ...filters,
  page,
  userDetails: user.details.data,
  customFilters,
});

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps),
)(LoggedIn);
